import { render, staticRenderFns } from "./LiveDetailCard.vue?vue&type=template&id=d8e20140&scoped=true"
import script from "./LiveDetailCard.vue?vue&type=script&lang=js"
export * from "./LiveDetailCard.vue?vue&type=script&lang=js"
import style0 from "./LiveDetailCard.vue?vue&type=style&index=0&id=d8e20140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e20140",
  null
  
)

export default component.exports